module.exports = __webpack_public_path__ + "static/media/全民创作者计划.40fe701e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/全民创作者计划.png
// module id = 1513
// module chunks = 0